import PropTypes from 'prop-types';
import ColorSwatchPicker from './ColorSwatchPicker.jsx';

/**
 * Colour swatch for a table row, keeping the `updateAccount(id, rgb)` shape
 * the group manager already calls. The palette itself is handled by
 * ColorSwatchPicker, which renders it in a portal so no scrolling ancestor
 * can clip it.
 */
export default function ColorPicker({ background, updateAccount, accountId }) {
  return (
    <ColorSwatchPicker
      value={background}
      onChange={(rgb) => updateAccount(accountId, rgb)}
      label="Changer la couleur"
      className="block h-3.5 w-9 rounded-full ring-1 ring-black/10"
    />
  );
}

ColorPicker.propTypes = {
  background: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  updateAccount: PropTypes.func.isRequired,
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
